import { RouteConfig } from 'vue-router';

const personalDataRouter: RouteConfig[] = [
  {
    name: 'PersonalData',
    path: '/personal-data/index',
    component: () =>
      import(
        /* webpackChunkName: "PersonalData" */ '@/views/personal-data/index.vue'
      ),
    meta: { title: '个人资料' },
  },
  {
    name: 'DriverInfo',
    path: '/personal-data/driver-info',
    component: () =>
      import(
        /* webpackChunkName: "DriverInfo" */ '@/views/personal-data/driver-info/index.vue'
      ),
    meta: { title: '个人信息' },
  },
  {
    name: 'OtherInfo',
    path: '/personal-data/other-info',
    component: () =>
      import(
        /* webpackChunkName: "OtherInfo" */ '@/views/personal-data/other-info/index.vue'
      ),
    meta: { title: '其它信息' },
  },
  {
    name: 'Updates',
    path: '/personal-data/updates',
    component: () =>
      import(
        /* webpackChunkName: "Updates" */ '@/views/personal-data/updates/index.vue'
      ),
    meta: { title: '补充资料' },
  },
  {
    name: 'EditInfo',
    path: '/personal-data/edit-info',
    component: () =>
      import(
        /* webpackChunkName: "EditInfo" */ '@/views/personal-data/edit-info/index.vue'
      ),
    meta: { title: '\u200E' },
  },
  {
    name: 'EditPhoneNewPhone',
    path: '/personal-data/edit-phone/new-phone',
    component: () =>
      import(
        /* webpackChunkName: "EditPhoneNewPhone" */ '@/views/personal-data/edit-info/new-phone/index.vue'
      ),
    meta: { title: '更换手机号' },
  },
  {
    name: 'VerifyCode',
    path: '/personal-data/edit-phone/verify-code',
    component: () =>
      import(
        /* webpackChunkName: "VerifyCode" */ '@/views/personal-data/edit-info/verify-code/index.vue'
      ),
    meta: { title: '更换手机号' },
  },
  {
    name: 'VehicleDetail',
    path: '/personal-data/vehicle-detail',
    component: () =>
      import(
        /* webpackChunkName: "VehicleInfo" */ '@/views/personal-data/vehicle-detail/index.vue'
      ),
    meta: { title: '车辆详情' },
  },
  {
    name: 'Supplement',
    path: '/personal-data/supplement',
    component: () =>
      import(
        /* webpackChunkName: "Supplement" */ '@/views/personal-data/supplement/index.vue'
      ),
    meta: { title: '补充资料' },
  },
  {
    name: 'UpdateLicense',
    path: '/personal-data/update-license',
    component: () =>
      import(
        /* webpackChunkName: "UpdateLicense" */ '@/views/personal-data/update-license/index.vue'
      ),
    meta: { title: '更新证件' },
  },
  {
    name: 'PerfectRetransmissionLicense', // 自动验证通过流程，需要重新更新资料
    path: '/personal-data/perfect-retransmission-license',
    component: () =>
      import(
        /* webpackChunkName: "UpdateLicense" */ '@/views/personal-data/perfect-retransmission-license/index.vue'
      ),
    meta: { title: '更新证件' },
  },

  {
    name: 'DrivingLicenseVideoProof',
    path: '/personal-data/driving-license-video-proof',
    component: () =>
      import(
        /* webpackChunkName: "driving-license-video-proof" */ '@/views/personal-data/driving-license-video-proof/index.vue'
      ),
    meta: { title: '行驶证视频证明' },
  },

  {
    name: 'AnnualSupplementary',
    path: '/personal-data/annual-supplementary',
    component: () =>
      import(
        /* webpackChunkName: "AnnualSupplementary" */ '@/views/personal-data/annual-supplementary/index.vue'
      ),
    meta: { title: '补充资料' },
  },

  {
    name: 'SupplementIdcard',
    path: '/personal-data/supplement-idcard',
    component: () =>
      import(
        /* webpackChunkName: "SupplementIdcard" */ '@/views/personal-data/supplement-idcard/index.vue'
      ),
    meta: { title: '上传证件' },
  },
];

export default personalDataRouter;
